import { PageType } from "shared/lib/page-type";

export const pathname = "/newsletters";

export const page = {
  route(query: QueryParameters<{ embed?: string; entityId?: string }>) {
    return {
      pathname,
      query: {
        ...query,
        pageType: PageType.Newsletter,
      },
    };
  },
};
